import { render, staticRenderFns } from "./literatureDetail.vue?vue&type=template&id=a054b176&scoped=true&"
import script from "./literatureDetail.vue?vue&type=script&lang=js&"
export * from "./literatureDetail.vue?vue&type=script&lang=js&"
import style0 from "./literatureDetail.vue?vue&type=style&index=0&id=a054b176&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a054b176",
  null
  
)

export default component.exports